// Generated by ReScript, PLEASE EDIT WITH CARE


var initial_state = {
  key_details: undefined,
  base_details: undefined,
  slab_details: undefined,
  eligiblity_rules: undefined
};

export {
  initial_state ,
  
}
/* No side effect */
